import { logFromConsoleApi } from '@core/core/api'
import objectInspect from 'object-inspect'

import { consoleSpy } from '../consoleSpy'

const stringify = (param: unknown): string => {
  return typeof param === 'string' || typeof param === 'number' || typeof param === 'boolean'
    ? param.toString()
    : objectInspect(param)
}

const logLogEvents = (...logParameters: unknown[]) => {
  logParameters.forEach(param => {
    logFromConsoleApi({
      logLevel: 'log',
      text: stringify(param),
    })
  })
}

const logWarnEvents = (...logParameters: unknown[]) => {
  logParameters.forEach(param => {
    logFromConsoleApi({
      logLevel: 'warn',
      text: stringify(param),
    })
  })
}

const logErrorEvents = (...logParameters: unknown[]) => {
  logParameters.forEach(param => {
    logFromConsoleApi({
      logLevel: 'error',
      text: stringify(param),
    })
  })
}

let isEnabled = false

export const loggingConsoleListeners = {
  enable() {
    if (isEnabled) {
      return
    }

    consoleSpy.addConsoleListener('log', logLogEvents)
    consoleSpy.addConsoleListener('warn', logWarnEvents)
    consoleSpy.addConsoleListener('error', logErrorEvents)
    isEnabled = true
  },
  disable() {
    consoleSpy.removeConsoleListener('log', logLogEvents)
    consoleSpy.removeConsoleListener('warn', logWarnEvents)
    consoleSpy.removeConsoleListener('error', logErrorEvents)
    isEnabled = false
  },
}
